var map = {
	"./1.png": "FNgA",
	"./2.png": "71kz",
	"./3.png": "Oj7n",
	"./4.png": "BzF0",
	"./5.png": "06dU",
	"./7.png": "J3Sw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OB2S";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/05/1 ^\.\/.*$
// module id = OB2S
// module chunks = 2